import { render, staticRenderFns } from "./AddLoRenameOnlinePayment.vue?vue&type=template&id=33e8a167&scoped=true"
import script from "./AddLoRenameOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddLoRenameOnlinePayment.vue?vue&type=script&lang=js"
import style0 from "./AddLoRenameOnlinePayment.vue?vue&type=style&index=0&id=33e8a167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8a167",
  null
  
)

export default component.exports